import { render } from "./dashboard.vue?vue&type=template&id=7916a657&scoped=true&ts=true"
import script from "./dashboard.vue?vue&type=script&lang=ts"
export * from "./dashboard.vue?vue&type=script&lang=ts"

import "./dashboard.vue?vue&type=style&index=0&id=7916a657&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7916a657"]])

export default __exports__